<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng
 * @Date: 2022-11-06 20:17:07
 * @LastEditTime: 2024-06-07 17:13:08
 * @Description: 
-->
<template>
    <div class="header">
        <div class="img_box">
            <!-- <img src="@/assets/img/ACNAClogo.png" class="tuv" alt=""> -->
            <img src="@/assets/img/Mvgx02_18.png" class="carbon" alt="">
            <div class="lineI"></div>
            <img src="@/assets/img/onelogo.png" class="tuvlogo_box" alt="">
        </div>
        <!-- <div class="txt">ACNAC碳中和评级报告</div> -->
        <div class="logo_txt">
            <div>本报告由ACNAC委托</div>
            <!-- <img src="@/assets/img/min_tuv.png" class="img_min" alt=""> -->
            <div>TÜV SÜD核证并发布</div>
        </div>
    </div>
</template>

<script>
</script>
<style scoped lang='less'>
.header{
    width: 100%;
    height: 110px;
    background: #003B88;
    padding: 0 130px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .img_box{
        display: flex;
        align-items: center;
    }
    .tuv{
        width: 79px;
        height: 69px;
    }
    .carbon{
        width: 150px;
        height: auto;
        margin-top: 15px;
    }
    .lineI{
        width: 1px;
        height: 60px;
        margin: 0px 20px 0 20px;
        background: #001d43;
    }
    .tuvlogo_box{
        width: 69px;
        height: 69px;
        // margin-left: 33px;
    }
    .txt{
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-top: 20px;
    }
    .logo_txt{
        font-size: 14px;
        font-weight: 400;
        padding-top: 38px;
        color: #FFFFFF;
        text-align: right;
        display: flex;
        align-items: center;
        .img_min{
            width: 24px;
            height: 24px;
            margin: 0 5px;
        }
    }
}
</style>